'use client';

import { useQuery } from '@apollo/client';
import { useEffect } from 'react';

import { CURRENT_MAINTENANCE } from '@/graphql/queries/currentMaintenance';

type Maintenance = {
  id: string;
  title: string;
  description: string;
  startAt: string;
  endAt: string;
  status: string;
};

type CurrentMaintenanceData = {
  currentMaintenance: Maintenance | null;
};

export function useMaintenance() {
  const { data, loading, error } = useQuery<CurrentMaintenanceData>(CURRENT_MAINTENANCE, {
    // ポーリング：1分ごとにメンテナンス状態をチェック
    pollInterval: 60000,
    // ネットワークエラーでもキャッシュを使用
    fetchPolicy: 'cache-and-network',
    // エラーも返すが、partial dataも使う（認証エラーの選別のため）
    errorPolicy: 'all',
    // ポーリング中は loading を変化させない（MaintenanceCheckerの全画面スピナーを防ぐ）
    notifyOnNetworkStatusChange: false,
  });

  useEffect(() => {
    if (!error) return;

    // 認証エラー（セッション確立前）は無視
    const isAuthError =
      error.message.includes('missing Authorization header') ||
      error.graphQLErrors?.some(
        e =>
          e.extensions?.code === 'UNAUTHENTICATED' ||
          e.extensions?.code === 'FORBIDDEN' ||
          e.message.includes('unauthorized') ||
          e.message.includes('not authenticated') ||
          e.message.includes('missing Authorization header'),
      );

    if (isAuthError) {
      console.debug('[useMaintenance] 認証前のクエリ実行（無視）:', error.message);
      return;
    }

    console.error('[useMaintenance] メンテナンスステータス取得エラー:', error);
  }, [error]);

  return {
    maintenance: data?.currentMaintenance || null,
    isUnderMaintenance: !!data?.currentMaintenance,
    loading,
    error,
  };
}
